import { defineStore } from 'pinia';
import { merge } from '@freelancerepublik/helpers';

interface FlashMessageAlert {
  id: string;
  message: string;
  time: number | null;
  colorClass: string;
}

export const useMessagesStore = defineStore('messages', {
  state: () => ({
    alerts: [] as FlashMessageAlert[],
  }),
  actions: {
    pushFlashMessage(alert: Partial<FlashMessageAlert> & { message: string }) {
      const _alert = merge(
        {
          time: alert.time || Math.min(20, Math.max(3, Math.floor(alert.message.length / 10))),
          colorClass: 'valid',
        },
        alert
      ) as FlashMessageAlert;

      _alert.id = [alert.id, Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)]
        .filter(s => s !== null && s !== undefined)
        .join('-');
      _alert.message = _alert.message.replace(/GraphQL error: /g, '');

      if (_alert.message.includes('Network error')) {
        _alert.message = 'Connexion avec le serveur impossible';
      }

      try {
        // Remove alert messages starting with the same ID prefix
        const [idPrefixToReplace] = _alert.id.split('-');
        this.alerts = this.alerts.filter(a => a.id.split('-')[0] !== idPrefixToReplace);
        this.alerts.push(_alert);
      } catch (err) {
        console.error(err);
      }

      // Hide only non-persistent messages
      if (_alert.time !== null) {
        setTimeout(() => {
          try {
            this.popFlashMessage(_alert.id);
          } catch (err) {
            console.error(err);
          }
        }, _alert.time * 1000);
      }

      return _alert.id;
    },
    popFlashMessage(id: string) {
      this.alerts = this.alerts.filter(element => element.id !== id);
    },
  },
});
